import { ElementProps } from '@readcloud/common';
import React, { ComponentPropsWithoutRef } from 'react';
import { AlphaPicker, TwitterPicker } from 'react-color';
import { FieldRenderProps } from 'react-final-form';
import { rgbToString } from './utils';

const colorOptions = [
  '#ff6900',
  '#fcb900',
  '#000000',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#ABB8C3',
  '#EB144C',
  '#F78DA7',
  '#9900EF',
  '#f9f9f9',
];
export function ColorPicker({
  onChange,
  color,
  children,
  disableAlpha,
  ...props
}: Pick<
  ComponentPropsWithoutRef<typeof TwitterPicker>,
  'onChange' | 'color'
> & {
  children?: React.ReactNode;
  disableAlpha?: boolean;
  className?: string;
}) {
  return (
    <div className="rc-w-full" {...props}>
      <TwitterPicker
        colors={colorOptions}
        width="100%"
        className={'annotation-color-picker'}
        triangle="hide"
        onChange={onChange}
        color={color}
      />
      {!disableAlpha ? (
        <div className='rc-w-full'>
          <span>Opacity</span>
          <div className="rc-p-1" />

          <AlphaPicker
            width="95%"
            className={'annotation-color-picker'}
            onChange={onChange}
            color={color}
          />
        </div>
      ) : null}
      {children}
    </div>
  );
}

export const ColorPickerField = React.memo(
  (
    props: FieldRenderProps<string, HTMLElement> &
      Omit<React.ComponentProps<typeof ColorPicker>, 'color' | 'onChange'>
  ) => {
    const { input, ...other } = props;
    return (
      <ColorPicker
        color={input.value}
        onChange={(change) => {
          input.onChange({ target: { value: rgbToString(change.rgb) } });
        }}
        {...other}
      />
    );
  }
);
